import * as url from "../url.helper";

import { post } from "../api.helper";

export const callITRUserCredinatialsSubmit = data => post(url.ITR_USRENAME_PASSWORD, data);
export const callGSTINUserCredinatialsSubmit = data => post(url.GST_USRENAME_PASSWORD, data);
export const callGSTINUserOTPSubmit = data => post(url.GST_USRENAME_OTP, data);
export const callGSTINUserOTPValidSubmit = data => post(url.GST_USRENAME_OTP_VALID, data);
export const callFinancialCINSubmit = data => post(url.FINANCIAL_CIN, data);
export const callProbeBAseApi = data => post(url.PROBE_BASE_API, data);
export const callGetProveBaseApi = data => post(url.GET_PROBE_BASIC_DETAILS, data);
export const callGetProbeCreditRatings = data => post(url.GET_PROBE_CREDIT_RATINGS, data);
export const callGetFinancialsSummary = data => post(url.GET_FINANCIAL_SUMMARY, data);
export const callUpdateFinancialsSummary = data => post(url.UPDATE_FINANCIAL_SUMMARY, data);
export const callFinancialOTPSubmit = (data, files, config) =>  {
    const formData = new FormData()
    formData.append("payload", JSON.stringify(data.payload))
    formData.append("file", files)
    formData.append("entity_id", data.entityId)

    return post(url.FINANCIAL_OTP, formData, config)
}
export const callITRUserFileUpload = (data, files, config) => {
    const formData = new FormData()
    formData.append("payload", JSON.stringify(data.payload))
    formData.append("file", files)
    formData.append("type", data.type)
    formData.append("entity_id", data.entityId)
    return post(url.ITR_FILE_UPLOAD, formData, config)
};
export const callITRUserXMLUpload = (data, files, config) => {
    const formData = new FormData()
    formData.append("payload", JSON.stringify(data.payload))
    formData.append("file", files)
    formData.append("entity_id", data.entityId)
    return post(url.ITR_XML_UPLOAD, formData, config)
};

export const callITRLists = data => post(url.ITR_DOCUMENT_LIST, data);
export const callGSTLists = data => post(url.GST_DOCUMENT_LIST, data);
export const callFinancialLists = data => post(url.FINANCIAL_DOCUMENT_LIST, data);
export const callBankStatementLists = data => post(url.BANK_STATEMENT_DOCUMENT_LIST, data);
export const callBureauLists = data => post(url.BUREAU_DOCUMENT_LIST, data);

export const callBSAFileUpload = (data, files, config) => {
    const formData = new FormData()
    formData.append("payload", JSON.stringify(data.payload))
    files.forEach(file => {
        formData.append("file", file)    
    });
    
    formData.append("entity_id", data.entityId)

    return post(url.BANK_STATEMENT_UPLOAD, formData, config)
};

export const callITRDeleteRecord = data => post(url.ITR_DOCUMENT_DELETE, data);
export const callGSTDeleteRecord = data => post(url.GST_DOCUMENT_DELETE, data);
export const callBSADeleteRecord = data => post(url.BANK_STATEMENT_DOCUMENT_DELETE, data);
export const callFinancialDeleteRecord = data => post(url.FINANCIAL_DOCUMENT_DELETE, data);
export const callBureauDeleteRecord = data => post(url.BUREAU_DOCUMENT_DELETE, data);
export const callBSAMergeSubmit= data => post(url.BANK_STATEMENT_MERGE, data);
export const callAdditionalDocument = (data)=>{
  post(url.ADD_ADDITIONAL_DOCUMENTs, data)
}
export const callgetAdditonalDocument = data => post(url.GET_ADDITIONAL_DOCUMENTs, data)
export const callDeleteDocuments = data => post(url.DELETE_DOCUMENTS, data)